import React from "react";
import "@locator/runtime";
import ReactDOM from "react-dom/client";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./assets/css/common.css";
import App from "./App";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import setupLocatorUI from "@locator/runtime";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
